import { motion } from "framer-motion";
import { GAMES } from "@/data/content";
import AnimatedVisual from "@/components/AnimatedVisual";

export default function GamesShowcase() {
  return (
    <section className="relative py-24 lg:py-32" data-testid="home-games">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6">
          <div className="max-w-2xl">
            <div className="overline">Game Portfolio</div>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
              10,000+ games. <span className="text-gradient-blue">One aggregator API.</span>
            </h2>
            <p className="mt-4 text-gray-400 max-w-xl">
              Live casino, slots, sportsbook, crash & instant win — all from 120+ premium studios.
            </p>
          </div>
          <div className="hidden md:flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gray-500">
            <span className="w-2 h-2 rounded-full bg-[#00D4FF]" /> Curated Portfolio
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {GAMES.map((g, i) => (
            <motion.div
              key={g.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: i * 0.04 }}
              data-testid={`game-card-${i}`}
              className="group relative rounded-2xl overflow-hidden aspect-[4/5] bg-[#0B1224] border border-white/10"
            >
              <AnimatedVisual variant={g.variant} className="absolute inset-0 group-hover:scale-[1.04]"
                              label={`${g.title} animation`}/>
              <div className="absolute inset-0 bg-gradient-to-t from-[#050816] via-[#050816]/40 to-transparent" />
              <div className="absolute bottom-3 left-3 right-3">
                <div className="text-[10px] uppercase tracking-[0.2em] text-[#00D4FF]">{g.tag}</div>
                <div className="mt-1 font-display font-semibold text-white text-lg">{g.title}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
